import { useObservable } from '../observable';
import { sectionsStateService } from '../sections.state.service';

export const useSectionsState = () => {
  const editedSectionId = useObservable(sectionsStateService.editedSectionId);
  const currentSection = useObservable(sectionsStateService.currentSection);
  const bundleSections = useObservable(sectionsStateService.bundleSections);
  const promotionSections = useObservable(
    sectionsStateService.promotionSections
  );

  return {
    editedSectionId: editedSectionId,
    setEditedSectionId: sectionsStateService.setEditedSectionId,
    currentSection: currentSection,
    setCurrentSection: sectionsStateService.setCurrentSection,
    bundleSections: bundleSections,
    setBundleSections: sectionsStateService.setBundleSections,
    promotionSections: promotionSections,
    setPromotionSections: sectionsStateService.setPromotionSections
  };
};
